import { Button, DatePicker, Form, Input, InputNumber, Select } from 'antd'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { GET } from '../../../utils/requestActionConstants';
import { API_ROUTE } from '../../../utils/commonConstants';
import { fetcher } from '../../../helpers/processRequest';
import useSWR from 'swr';
import { addReview, updateReview } from '../../../store/slices/reviewSlice';
import dayjs from 'dayjs';

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 6,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 14,
    },
  },
};

function AddReview({ onSwitchTab, tabProps = {} }) {
  const review = useSelector(state => state.reviewSlice.review);
  const users = useSelector(state => state.userSlice.userList);
  const products = useSelector(state => state.productSlice.productList);
  const loading = useSelector(state => state.reviewSlice.loading);

  const [form] = Form.useForm();
  const dispatch = useDispatch();

  useEffect(() => {
    loadValues();
  }, [review]);

  const loadValues = () => {
    if (review.id) {
      form.setFieldsValue({...review, createdAt: dayjs(review.createdAt)});
    } else {
      form.resetFields();
      onSwitchTab("1");
    }
  }

  const saveReview = (data) => {
    if (review.id) {
      dispatch(updateReview({ reviewId: review.id, reviewData: data }));
    } else {
      dispatch(addReview({ reviewData: data }));
    }
  }

  return (
    <div>
      <div className='text-center py-2 mb-10 mt-5 font-bold p-5 rounded-lg mx-auto w-fit text-xl '>{review.id ? "Update review" : "Add New review"}</div>
      <Form
        form={form}
        layout='verticle'
        {...formItemLayout}
        style={{
          maxWidth: 600,
          margin: 'auto'
        }}
        onFinish={saveReview}
      >
        <Form.Item
          label="Review Comment"
          name="comment"
          rules={[
            {
              required: true,
              message: 'Enter review comment here',
            },
          ]}
        >
          <Input.TextArea placeholder='Comment of the review' />
        </Form.Item>

        <Form.Item
          label="Rating"
          name="rating"
          rules={[
            {
              required: true,
              message: 'Enter rating here',
            },
          ]}
        >
          <Select
            placeholder="Select Rating"
          >
            <Select.Option value={1}>1</Select.Option>
            <Select.Option value={2}>2</Select.Option>
            <Select.Option value={3}>3</Select.Option>
            <Select.Option value={4}>4</Select.Option>
            <Select.Option value={5}>5</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item
          label="User"
          name="userId"
          rules={[
            {
              required: true,
              message: 'Enter user here',
            },
          ]}
        >
          <Select
            placeholder="Select User"
            showSearch
            optionFilterProp="label"
            options={users.map(user => ({ value: user.id, label: `${user.name}` }))}
           />
        </Form.Item>

        <Form.Item
          label="Product"
          name="productId"
          rules={[
            {
              required: true,
              message: 'Enter product here',
            },
          ]}
        >
          <Select
            placeholder="Select Product"
            showSearch
            optionFilterProp="label"
            options={products.map(product => ({ value: product.id, label: `${product.name}` }))}
           />
        </Form.Item>

        <Form.Item
          label="Created At"
          name="createdAt"
          rules={[
            {
              required: true,
              message: 'Enter review created at here',
            },
          ]}
        >
          <DatePicker />
        </Form.Item>

        <Form.Item wrapperCol={{ sm: { offset: 6, span: 14 }, xs: { offset: 0, span: 14 } }}>
          <div className='flex justify-between'>
            <div>{review.id ? <Button onClick={loadValues}>Revert Changes</Button> : <></>}</div>
            <div className='flex'>
              <Button danger type='text' htmlType='reset'>Clear</Button>
              <Button type='primary' loading={loading.saving} htmlType='submit'>{review.id ? "Update" : "Save"}</Button>
            </div>
          </div>
        </Form.Item>
      </Form>
    </div>
  )
}

export default AddReview